import { useSelector } from 'react-redux'

import { Roles } from 'clickNgo/configs/roles'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

export const useCheckSuperAdminAccess = () => {
  const user = useSelector(selectUser)

  return user.roleIds.includes(Roles.SUPER_ADMIN_ROLE)
}
